import React from 'react';

import DatePicker from '@/components/DatePicker';
import InlineDatePicker from '@/components/InlineDatePicker';

import useTagDatePicker from './hooks/useTagDatePicker';
import { TagDatePickerProps } from './types';

function InlineTagDatePicker(props: TagDatePickerProps) {
  const { showActionButtons } = props;
  const { pickerProps } = useTagDatePicker(props);

  return (
    <InlineDatePicker
      showSelectedTime
      className="xs:w-full"
      pickerProps={pickerProps}
      showActionButtons={showActionButtons}
    />
  );
}

function TagDatePicker(props: TagDatePickerProps) {
  const { children, open, onToggle, showActionButtons } = props;
  const { pickerProps } = useTagDatePicker(props);

  return (
    <DatePicker
      open={open}
      pickerProps={pickerProps}
      showActionButtons={showActionButtons}
      onOpenChange={onToggle}>
      {children}
    </DatePicker>
  );
}

export { InlineTagDatePicker };
export default TagDatePicker;
